import Link from 'next/link';
import { ImageWithFocalPointFieldsFragment, ShortcutLinksFieldsFragment } from '../../@types/generated';
import { getOr } from '../utils/options';
import Image from 'next/image';

type Props = {
  data: ShortcutLinksFieldsFragment;
};

const renderShortcut = (
  index: number,
  title: string,
  subtitle: string,
  hideText: boolean,
  uri: string,
  image?: ImageWithFocalPointFieldsFragment | null,
  isFullImage?: boolean | null
) => (
  <Link
    key={index}
    href={uri}
    className="max-w-[280px] flex-1 rounded-28 bg-white-100 text-center transition-all hover:scale-105 hover:cursor-pointer"
  >
    <div tabIndex={0} className="flex h-full items-center justify-center px-big pb-xbig pt-48">
      <div className="grid min-w-[256px] gap-24">
        {image &&
          image.image &&
          image.image.url &&
          (isFullImage ? (
            <Image alt={image.title || ''} src={image.image.url} width={160} height={160} />
          ) : (
            <div className="relative m-auto flex h-100 w-100 items-center justify-center rounded-full bg-red-100">
              <div className="h-64 w-64">
                <Image alt={image.title || ''} src={image.image.url} width={64} height={64} />
              </div>
            </div>
          ))}
        <div className={`${hideText ? 'hidden' : 'block'}`}>
          <p className="headline-lg text-red-100">{title}</p>
          <p className="title-lg text-red-100">{subtitle}</p>
        </div>
      </div>
    </div>
  </Link>
);

const ShortcutLinks = ({ data }: Props) => {
  if (data.shortcutLinkCollection?.items === undefined || null) {
    return null;
  }

  return (
    <div className={'flex flex-wrap place-content-center gap-24'}>
      {data.shortcutLinkCollection.items.map((shortcut, index) => {
        const title = getOr(shortcut?.title, '');
        const subtitle = getOr(shortcut?.subtitle, '');
        const hideText = getOr(shortcut?.hideText, false);
        const uri = getOr(shortcut?.uri, '/');
        const isFullImage = getOr(shortcut?.isFullImage, false);

        return renderShortcut(index, title, subtitle, hideText, uri, shortcut?.image, isFullImage);
      })}
    </div>
  );
};
export default ShortcutLinks;
